module.exports = __webpack_public_path__ + "media/images/icons/spa_facility-18cc63e659138c75554694c0f7405b8e.png";